import React, { useState } from 'react';
import { FaSlidersH } from 'react-icons/fa';

const Step4Checks = () => {
  const [rolesChecks, setRolesChecks] = useState([
    { role: 'Head Chef', checks: ['Food Safety Check', 'Food Temperature Check', 'Opening Check'], extra: 2, enabled: true },
    { role: 'Server', checks: ['Cleaning Check', 'Closing Check', 'Allergen Check'], extra: 1, enabled: true },
    { role: 'Kitchen Assistant', checks: ['Temperature Check', 'Cleaning Check', 'Equipment Check'], extra: 0, enabled: true },
    { role: 'Manager', checks: ['Opening Check', 'Closing Check', 'Incident Log Review'], extra: 0, enabled: true },
    { role: 'Cleaner', checks: ['Cleaning Check'], extra: 0, enabled: true }
  ]);

  const toggleRoleApply = (index) => {
    const updated = [...rolesChecks];
    updated[index].enabled = !updated[index].enabled;
    setRolesChecks(updated);
  };

  return (
    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-5">
        <div className="flex items-center gap-2.5">
          <div className="w-7 h-7 rounded-md bg-blue-600 flex items-center justify-center text-white font-bold text-sm">4</div>
          <div>
            <h2 className="text-md font-bold text-gray-900">Assign Checks</h2>
            <p className="text-[11px] text-gray-400">Choose which checks each role will be responsible for (links to the Checks module).</p>
          </div>
        </div>
        <button className="flex items-center gap-1.5 px-2.5 py-1.5 border border-gray-300 rounded text-xs font-semibold text-gray-600 bg-white hover:bg-gray-50 shadow-sm">
          <FaSlidersH className="text-gray-400" size={11} /> Manage Check Templates
        </button>
      </div>

      <div className="overflow-x-auto rounded-md border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200 text-left text-xs font-medium">
          <thead className="bg-slate-50 text-[10px] font-bold text-gray-400 uppercase tracking-wider border-b border-gray-200">
            <tr>
              <th className="p-3 w-1/4">Role</th>
              <th className="p-3 w-3/5">Default Checks To Assign</th>
              <th className="p-3 text-center w-28">Apply to Rota</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200 text-gray-700">
            {rolesChecks.map((item, idx) => (
              <tr key={idx} className="hover:bg-slate-50 transition">
                <td className="p-3 font-bold text-gray-900 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
                  {item.role}
                </td>
                <td className="p-3">
                  <div className="flex flex-wrap gap-1.5">
                    {item.checks.map((check, cIdx) => (
                      <span key={cIdx} className="bg-slate-50 text-gray-600 px-2 py-0.5 rounded border border-gray-200 text-[10px] font-semibold">
                        {check}
                      </span>
                    ))}
                    {item.extra > 0 && (
                      <span className="bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded font-bold text-[10px] border border-blue-100">
                        +{item.extra}
                      </span>
                    )}
                  </div>
                </td>
                <td className="p-3">
                  <div className="flex items-center justify-center gap-3">
                    <span className="text-[10px] font-bold text-gray-400 w-6">
                      {item.enabled ? 'Yes' : 'No'}
                    </span>
                    <button
                      type="button"
                      onClick={() => toggleRoleApply(idx)}
                      className={`w-8 h-4.5 flex items-center rounded-full p-0.5 transition-colors duration-200 focus:outline-none ${item.enabled ? 'bg-blue-600' : 'bg-gray-300'}`}
                    >
                      <div className={`bg-white w-3.5 h-3.5 rounded-full shadow transform transition-transform duration-200 ${item.enabled ? 'translate-x-3.5' : 'translate-x-0'}`} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Step4Checks;
